import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  email: any;
  password: any;
  message: string = '';
  loading: boolean = false;
  showPassword: boolean = false;

  constructor(public utility: UtilitiesService,
    private router: Router, private api: ApiService) { this.utility.show = false; }

  ngOnInit(): void { }

  login() {
    if (this.email == null || this.password == null) {
      this.message = "All Fields are Required.";
    }
    else {
      this.loading = true;
      const body = {
        email: this.email,
        password: this.password
      };

      const sub = this.api.login(body, 'login/').subscribe(
        async data => {
          if (data) {
            let userSession = JSON.parse(JSON.stringify(data));
            this.api.setToken(userSession);
            this.router.navigate(['home']);
          }
          else {
            this.message = "Access Denied";
          }
        },
        async error => {
          this.message = "Error: Cannot Sign in!";
        }
      );

      sub.add(() => { this.loading = false; });
    }
  }

  forget() {
    this.router.navigate(['forget']);
  }

  getDetails(id: any, token: any) {
    const sub = this.api.get('employees/user/' + id, token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        localStorage.setItem('employee', JSON.stringify(objects));
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }
}
